<template>
  <p class="fst-italic text-muted">
    <span class="bi bi-exclamation-circle me-1"></span>
    <slot>Complete the form below to proceed.</slot>
    Fields with an asterisk (*) are required.
  </p>
</template>
